export default "/images/vendor/flag-icon-css/flags/1x1/lk.svg?25692a40953691400c9924f6fd2657c9";